export class JSendError extends Error {
  public data: Record<string, unknown> | undefined;

  constructor(
    message: string,
    options: {
      cause: unknown;
      data?: Record<string, unknown>;
    },
  ) {
    super(message, {
      cause: options.cause,
    });

    this.data = options.data;
  }
}
